import Router from '@/router/index.js'
import { getMenuByUserId, selectPermsByToken } from '@/api/crm'
const state = {
  nowPower: [],
  newList: [],
  userType: '',
  userId: '',
  userName: '',
  isLogin: false,
  userServiceMsg: null
}
const mutations = {
  changeIsLogin (state, val) {
    state.isLogin = val
  },
  changeUserMsg (state, val) {
    state.userId = val[0]
    state.storeId = val[1]
    state.userType = val[2]
    state.storeCode = val[3]
    state.storeName = val[4]
  },
  changeUserType (state, val) {
    state.userType = val
  },
  userServiceMsg (state, val) {
    state.serviceMsg = val
  },
  changePower (state, obj) {
    state.nowPower = obj
  },
  changeNewList (state, val) {
    state.newList = val
  }
}
const actions = {
  getList ({ state, commit, dispatch }, path) {
    getMenuByUserId(window.localStorage.getItem('userId')).then((res) => {
      console.log(res)
      dispatch('getPower', res.data.data[0].children)
      if (res.data.success) {
        // this.newList = res.data.data[0].children
        let menus = res.data.data[0].children
        //
        commit('changeNewList', menus)
        Router.push(path)
      }
    })
  },
  getPower ({ commit }, val) {
    let obj = []
    let obj2 = {}
    val.forEach(item => {
      item.children.forEach(el => {
        obj2[el.component] = []
        for (let key in el.children) {
          if (el.children[key].perms === '') {
          }
          obj.push(el.children[key].perms)
          obj2[el.component].push({ id: el.children[key].id, perms: el.children[key].perms, name: el.children[key].name })
        }
      })
    })
    commit('changePower', obj)
  }
}
const getters = {
  perms: (state) => state.nowPower
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
